
import React from 'react'
import { Box, CircularProgress } from '@mui/material'

function Loader() {
  return (
    <>
    
    <Box sx={{
        position:'fixed',
        height:'100%',
        width:'100%',
        zIndex: 9999,
        backgroundColor:'#00000099',
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
    }}
    >
        <Box>
            <CircularProgress/>
        </Box>
    </Box>
    
    </>
  )
}

export default Loader